var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PriceStructView',{attrs:{"quote-obj":_vm.rows,"platform-type":_vm.platformType}})
}
var staticRenderFns = []

export { render, staticRenderFns }